/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, RouteComponentProps } from "react-router-dom";
import { faq, getActiveFaq, rateArticle } from "../../store/modules/FaqStore";
import Footer from "../../components/layout/Footer";
import "../../styles/faqDetail.css";

// for printing a component
// import ReactToPrint from "react-to-print";
import {
  Article,
  ArticleContainer,
  Encuesta,
  EncuestaForm,
  EncuestaBtn,
  //   Observaciones,
  ReturnLink,
  ThumbImage,
  //   EncuestaSubmit,
} from "../../components/FAQPage/faqElements";
import thumbsUp from "../../components/svg/thumbs-up.png";
import thumbsDown from "../../components/svg/thumbs-down.png";
import { Adjuntar } from "../../components/svg/Adjuntar";
import { useTranslation } from "react-i18next";
import TranslatableText from "../../components/Multilanguage/TranslatableText";
import { useTranslationContext } from "../../context/TranslationContext";

type TParams = { id: string };

const ListFaq = ({ match }: RouteComponentProps<TParams>) => {
  const dispatch = useDispatch();
  const componentRef = useRef<HTMLDivElement>(null);
  const [checked, setChecked] = useState("");
  const [hideEncuesta, setHideEncuesta] = useState(false);
  const { translateText, targetLang } = useTranslationContext()

  const { t } = useTranslation();

  useEffect(() => {
    dispatch(getActiveFaq(parseInt(match.params.id)));
  }, []);

  useEffect(() => {
    if (checked === "true") {
      dispatch(rateArticle(parseInt(match.params.id), true, ""));
    } else if (checked === "false") {
      dispatch(rateArticle(parseInt(match.params.id), false, ""));
    }
    setChecked("");
    checked !== "" && setHideEncuesta(true);
  }, [checked]);

  const [translatedHtml, setTranslatedHtml] = useState('');

  const faqList = useSelector(faq);
  const downloadFile = (fileName: string, path: string) => {
    // axios
    //   .get(path, {
    //     headers: {
    //       // "Access-Control-Allow-Origin": "*",
    //       "Content-Type": "application/pdf",
    //     },
    //   })
    //   .then((data) => {
    //     console.log(data);
    //   });
    // const url = window.URL.createObjectURL(new Blob([path]));
    // console.log("daniel", path);

    const link = document.createElement("a");
    link.href = path;
    link.download = fileName; // Cambia el nombre del archivo según tus necesidades
    link.rel = "noopener noreferrer";
    link.click();
    // const link = document.createElement("a");
    // link.href = path;
    // link.setAttribute("download", fileName);
    // document.body.appendChild(link);
    // link.rel = "noopener noreferrer";
    // link.click();
    // link.parentNode?.removeChild(link);
  };

  useEffect(() => {
    const translate = async () => {
      try {
        const result = await translateText(faqList.active.answer, "html");
        setTranslatedHtml(result);
      } catch (error) {
        console.error(error);
        setTranslatedHtml(faqList.active.answer);
      }
    };

    if (targetLang && targetLang !== "es") {
      translate();
    } else {
      setTranslatedHtml(faqList?.active?.answer);
    }
  }, [faqList.active.answer]);

  return (
    <ArticleContainer>
      <div className="flex items-start">
        <Link to={"/faq/all"}>
          <svg
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 17L6 12M6 12L11 7M6 12L18 12"
              stroke="#111827"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Link>
      </div>
      <Article>
        <div ref={componentRef}>
          <h1 className="text-2xl mt-8 font-bold text-blue-700">
            <TranslatableText text={faqList.active.question} />
          </h1>
          <div
            className="mt-4"
            dangerouslySetInnerHTML={{
              __html: translatedHtml,
              // __html: faqList.active.answer,
            }}
          />
        </div>
        <div>
          <h6 className="text-2xl mt-8 font-bold text-blue-700">
            {t("faq.details.attachments")}
          </h6>
          {faqList.active.attachments &&
            faqList.active.attachments.length > 0 && (
              <div>
                {faqList.active.attachments.map((adj) => {
                  return (
                    // <button
                    //   onClick={() => {
                    //     downloadFile(adj.AttachmentName, adj.AttachmentRoute);
                    //   }}
                    //   className="mr-7"
                    // >
                    //   {adj.AttachmentName}
                    // </button>
                    <a
                      href={adj.AttachmentRoute}
                      className="adj-download mr-7"
                      target="_blank"
                      rel="noreferrer"
                      download={adj.AttachmentName}
                    >
                      {adj.AttachmentName}
                      {/* <img src={adj.AttachmentRoute} alt={adj.AttachmentName} /> */}
                    </a>
                  );
                })}
              </div>
            )}
        </div>
      </Article>
      <div className="flex w-full items-center justify-center mt-10 mb-10 md:mb-0">
        <ReturnLink className="text-blue-700" to="/faq/all">
          {t("faq.details.viewAllArticles")}
        </ReturnLink>
      </div>
      {hideEncuesta ? (
        <Encuesta>
          <div className="px-2 flex text-center">
            <p className="font-semibold" style={{ color: "#3DEA83" }}>
              {t("faq.details.thanks")}
            </p>
          </div>
          <div className="flex items-center justify-center">
            <EncuestaBtn onClick={() => setHideEncuesta(false)} colorGray>
              {t("faq.details.editAnswer")}
            </EncuestaBtn>
          </div>
        </Encuesta>
      ) : (
        <Encuesta>
          <EncuestaForm action="">
            <div className="px-2 flex text-center">
              <p className="font-semibold" style={{ color: "#3DEA83" }}>
                {t("faq.details.textUseful")}
              </p>
            </div>
            <hr className="bg-gray-300 w-full h-0.25" />
            <div className="grid grid-cols-2 mt-2 w-full gap-3">
              <EncuestaBtn checked={checked === "true"}>
                {t("faq.details.yes")}{" "}
                <ThumbImage src={thumbsUp} alt="thumbs up" />
                <input
                  type="radio"
                  value="true"
                  hidden
                  checked={checked === "true"}
                  onChange={(e) => {
                    setChecked("true");
                  }}
                />
              </EncuestaBtn>
              <EncuestaBtn checked={checked === "false"}>
                {t("faq.details.no")}{" "}
                <ThumbImage src={thumbsDown} alt="thumbs down" />
                <input
                  type="radio"
                  value="false"
                  hidden
                  checked={checked === "false"}
                  onChange={(e) => {
                    setChecked("false");
                  }}
                />
              </EncuestaBtn>
            </div>
          </EncuestaForm>
        </Encuesta>
      )}
      {/* <Footer /> */}
    </ArticleContainer>
  );
};

export default ListFaq;
